<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
    >
      <v-card>
        <v-card-title class="text-h5 d-flex justify-center">
          DELETE TARIFF
        </v-card-title>
        <v-card-text class="d-flex justify-center">Are you sure?</v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            color="green darken-1"
            text
            :disabled="loading"
            @click="hideDeleteTariff"
          >
            CANCEL
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="loading"
            @click="delTarriff"
          >
            DELETE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog'],
    name: 'DeleteTariff',
    data(){
      return {
        loading: false,
        tariffId: null
      }
    },
    components:{
    },
    computed:{
      ...mapGetters([]),
      isNotValidStep1(){
        return this.tariffId == null 
      },
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    mounted(){
      this.$root.$on("deleteTariff", (id) => {
        this.tariffId = id
      })
    },
    methods:{
      ...mapActions(['deleteTariff']),
      async delTarriff(){
        this.loading = true
        this.$root.$emit('loading', "start")
        await this.deleteTariff(this.tariffId)
        .then(res => {
          console.log(res)
          this.$root.$emit('loading', "end")
          this.$noty.success(`Success`)
          this.loading = false
          this.$root.$emit("updateTariffTable")
          this.$emit('hideDeleteTariff')
        })
        .catch(er => {
          console.log(er)
          this.$root.$emit('loading', "end")
          this.$noty.error(`Error: ${er.description}`)
          this.loading = false
        })
      },
      hideDeleteTariff(){
        this.$emit('hideDeleteTariff')
      }
    }
  }
</script>
<style>
</style>
